import React, { useEffect } from "react";
import { FaBuilding, FaMapMarkedAlt, FaHandshake, FaShieldAlt } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

const whyUsData = [
  {
    id: 1,
    icon: <FaBuilding />,
    title: "Premium Developments",
    description:
      "Thoughtfully designed real-estate projects with modern architecture and superior construction quality."
  },
  {
    id: 2,
    icon: <FaMapMarkedAlt />,
    title: "Prime Locations",
    description:
      "Strategically located properties ensuring excellent connectivity and long-term value appreciation."
  },
  {
    id: 3,
    icon: <FaHandshake />,
    title: "Trusted Relationships",
    description:
      "Transparent processes and long-term relationships built on trust and customer satisfaction."
  },
  {
    id: 4,
    icon: <FaShieldAlt />,
    title: "Legal & Safety Assurance",
    description:
      "All projects comply with legal regulations, approvals, and quality standards."
  }
];

const WhyUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false
    });
  }, []);

  return (
    <section className="saptbackdivv">
      <div className="backdiv">
        <h2
          className="sapt-head-white text-center"
        >
          WHY CHOOSE US?
        </h2>

        <div className="whyus-grid">
    
          <div
            className="whyus-sect1"
          >
            <img
              src="./why-us.webp"
              className="img-cover"
              alt="sapt"
              loading="lazy"
            />
          </div>


          <div>
            {whyUsData.map((item, index) => (
              <div
                className="whyus-card"
                key={item.id}
                data-aos="fade-up"
                data-aos-delay={index * 150}
              >
                <div className="whyicon-div">
                  <div className="whyus-icon">{item.icon}</div>
                </div>

                <div className="whyicon-div">
                  <div>
                    <h4 className="why-head">{item.title}</h4>
                    <p className="why-desc">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyUs;
